import React, { useState, useEffect } from "react";
import "../Styles/Aboutus.css";
import AboutBigImg from "../assets/Header-Images/AboutusBig.png";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
const AboutUs = () => {
  const { t } = useTranslation(); // Initialize translation function
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="about-section">
      <div className="about-text">
        <span className="about-badge">About Us</span>
        <h2 className="about-title">{t("aboutUs.title")}</h2>
        <p className="about-subtitle">
          <i>{t("aboutUs.subtitle")}</i>
        </p>
        <p className="about-description">
        {t("aboutUs.description1")}
        </p>

        {/* Desktop view ke liye second paragraph ko yahin rakhna hai */}
        {!isMobile && (
          <p className="about-description">
           {t("aboutUs.description2")}
          </p>
        )}
      </div>

      {/* Image Section */}
      <div className="about-images">
        <div className="main-image-container">
          <img src={AboutBigImg} alt="Factory" className="main-image" />
        </div>
      </div>

      {/* Mobile View ke liye second paragraph alag se dikhe */}
      {isMobile && (
        <div className="about-text">
          <p className="about-description">
          {t("aboutUs.description2")}
          </p>
        </div>
      )}
    </section>
  );
};

export default AboutUs;
